// src/hooks/useLockBodyScroll.ts
import { useLayoutEffect, useRef } from "react";
var updateOverflow = (overflow) => document.body.style.overflow = overflow;
var useLockBodyScroll = (shouldLock = true) => {
  const originalOverflow = useRef("");
  useLayoutEffect(() => {
    if (!originalOverflow.current) {
      originalOverflow.current = window.getComputedStyle(
        document.body
      ).overflow;
    }
    if (shouldLock) {
      updateOverflow("hidden");
    } else {
      updateOverflow(originalOverflow.current);
    }
    return () => updateOverflow(originalOverflow.current);
  }, [shouldLock]);
};
var useLockBodyScroll_default = useLockBodyScroll;
export {
  useLockBodyScroll_default as default,
  useLockBodyScroll
};
//# sourceMappingURL=useLockBodyScroll.mjs.map